import { $Q, $Qll } from '../utils/query-selector';

/**
* Destructure the expression with the europe money code.
* @param {string} str string with the price.
* @return money number ej. input €3,45 return 3.45
*/

function formatPrice(str) {
  return parseFloat(
    str
      .match(/\d+/g)
      .join(''),
  ) / 100;
}

/**
* Estructure the money with currency value
* @param {string} str string with the price type number.
* @return money number with europe money code ej. input 3.45 return €3,45
*/

export function concatRegexp(initial, exp) {
  return initial.replace(/\d+,\d+/g, exp).replace('.', ',');
}

/**
* Calls the functions:
* {} To capture the variants.
* {} Makes the modification of the amounts
* @param {object} parent Parent element of the container.
* @param {number} qty quantity in the input element.
*/

export function modifyPrice(parent, qty) {
  const price = $Q('.regular', parent);
  const newprice =
  (qty * formatPrice(price.dataset.price)).toFixed(2);
  price.innerHTML = concatRegexp(price.innerText, newprice);
}

/**
* read the onchange input of the product element and the modal
* an active de function depend of that.
*/

export const onChangeItemProduct = () => {
  const parentinput = $Q('.product-controls')

  if (parentinput) {
    $Qll('.js-input-quantity').forEach(
      (input) => {
        input.addEventListener(
          'change',
          () => {
            modifyPrice(input.closest('.product-controls'), input.value);
          },
        )
      },
    )
  }
}
